import React from "react";
import MUIDataTable from "mui-datatables";
import { connect } from 'react-redux';
import lodash from 'lodash';
import moment from 'moment'

// @material-ui/core components
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import Button from 'components/CustomButtons/Button'

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import MTablestyles from "assets/jss/material-dashboard-pro-react/customMTableStyle.jsx";

// import Badge from "components/Badge/Badge.jsx";

import { plugins } from 'helpers';

import { dashboardServices } from 'services';
import { dashboardActions } from "actions/dashboard.actions";


const style = {
    customCardContentClass: {
        paddingLeft: "0",
        paddingRight: "0"
    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "15px",
        marginBottom: "0px"
    },
    actionDiv: {
        display: "inline-flex"
    }
};

const pageStyle = { ...style };

const THEME = createMuiTheme({
    ...MTablestyles,
    overrides: {
        ...MTablestyles.overrides,
        MuiTableCell: {
            head: {
                textAlign: "center",
                paddingRight: '24px',
            },
            body: {
                textAlign: "center",
                paddingRight: '24px',
            },
        },
    }
});

class TableDailyRegistrationDashboardList extends React.Component {
    
    componentDidMount(){
        const { tableDialyRegistrationFilter, dispatch } = this.props;
        dispatch(dashboardActions.getTableDailyRegistrationDatas(tableDialyRegistrationFilter));
        dispatch({type: 'DASHBOARD_RESET_ACTIVE_DAILY_REGISTRATION', tableDialyRegistrationFilter })
    }

    getRowData(rowIndex = 0) {
        const { tableDialyRegistrationDatas } = this.props;
        var data = tableDialyRegistrationDatas;
        return data[rowIndex];
    }

    getDownloadFile(id) {
        dashboardServices.getFileDownloadRegister(id)
        .then(
            tmp => {        
                if (lodash.get(tmp, 'status') === true) {
                    window.location.assign(tmp.link)
                }
            }
        )
    }

    render() {
        const { showLoader, tableDialyRegistrationDatas,  tableDialyRegistrationTotal, tableDialyRegistrationFilter, visiblePersonalData } = this.props;
        var labelReportDate = 'Daily';
       
        console.log('tableDialyRegistrationDatas :',tableDialyRegistrationDatas)
        let columns = [
            { name: "_id", options: { filter: false, display: "excluded" } },
            { name: "displayId", options: { filter: false, display: "excluded" } },
            {
                name: "reportDate", label: labelReportDate
                // ,
                // options: {
                //     filter: false,
                //     customBodyRender: (value, tableMeta) => {
                //         const rowData = this.getRowData(tableMeta.rowIndex)
                //         if (rowData.reportDate !== undefined && rowData.reportDate != null) { 
                //             return (<p className="text-nowrap">{plugins.datetimeFormat(rowData.reportDate, "date")}</p>)
                //         } else {
                //             return "";
                //         }
                //     }
                // }
            },
            {
                name: "count", label: "Total User"
            },
            {
                name: "detail", label: "Detail",
                options: {
                    display: (plugins.isHasPermission("dashboard", 'export') && plugins.isHasPackageFeatures('export') && visiblePersonalData),
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const rowData = this.getRowData(tableMeta.rowIndex)
                        return (
                            <>
                                <Button
                                    id = "btn_export_csv"
                                    variant="contained"
                                    bcolor="primary"
                                    size="sm"
                                    onClick={(e) => { 
                                        this.getDownloadFile(rowData._id)
                                    }}
                                    style={{ backgroundColor: "#84B0F3" }}
                                    disabled={lodash.get(rowData, '_id') ? false : true}
                                >
                                    Export
                                </Button>

                            </>
                        );

                    }
                }

            },
        ]

        let options = {
            serverSide: false,
            rowsPerPage: 10,
            selectableRows: "none",
            print: false,
            download: false,
            filter: false,
            responsive: "scroll",
            rowsPerPageOptions: [5, 10, 31],
            search: false,
            viewColumns: false,
            sort: false,
            paging: false
        };

        // if(tableFilter.search.type === 'period' || tableFilter.search.type === 'monthly'){
        //     options.customFooter = () => {
        //         return (<></>)
        //     }
        //     if ( this.props.tableFilter.search.type === 'monthly' ) {
        //         options = {
        //             ...options,
        //             rowsPerPage: 12,
        //         }    
        //     }
        // }

        return (
            <div id="tableDailyRegistrationDashboardList">
                <MuiThemeProvider theme={THEME}>
                    <MUIDataTable
                        key={showLoader?0:1}
                        data={tableDialyRegistrationDatas}
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { showLoader, tableDialyRegistrationDatas, tableDialyRegistrationTotal, tableDialyRegistrationFilter } = state.dashboard;
    const { formFilterDailyRegistration } = state.form;
    const { visiblePersonalData } = state.authentication;
    return {
        formFilterDailyRegistration, showLoader, tableDialyRegistrationDatas, tableDialyRegistrationTotal, tableDialyRegistrationFilter, visiblePersonalData
    };
}
export default connect(mapStateToProps)(withStyles(pageStyle)(TableDailyRegistrationDashboardList));  